import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import InputFree from "../../component/inputfree";
import Calendar from "react-calendar";
import moment from "moment";
import { AntDesign } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import Modal from "modal-react-native-web";
import RNPickerSelect from "react-native-picker-select";
import { pickImage } from "../../action/authImage";
import { apiservice } from "../../service/service";
import * as DocumentPicker from "expo-document-picker";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useIsFocused } from "@react-navigation/native";
const { width, height } = Dimensions.get("window");

export default function editrole({ navigation, route }) {
  const focus = useIsFocused();
  const [modalresult, setModalresult] = useState(false);
  const [token, setToken] = useRecoilState(tokenState);
  const [locate, setLo] = useState({});
  const [handelCalendar, setHandelCalendar] = useState(false);
  const [dateState, setDateState] = useState(new Date());
  const [day, setday] = useState(new Date());
  const [locate1, setLo1] = useState({});
  const [handelCalendar1, setHandelCalendar1] = useState(false);
  const [dateState1, setDateState1] = useState(new Date());
  const [day1, setday1] = useState(new Date());
  const placeholder = {
    label: "สถานะ",
    value: null,
    color: "#777777",
  };
  const [items, setItems] = useState([
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ]);
  const placeholder2 = {
    label: "ของรางวัล",
    value: "",
    color: "#777777",
  };
  const [items2, setItems2] = useState([
    { label: "โกลด์", value: "โกลด์" },
    { label: "ไดมอนด์", value: "ไดมอนด์" },
    { label: "ไอเทม", value: "ไอเทม" },
  ]);
  const [dataReward, setDataReward] = useState([]);
  const [body, setbody] = useState({
    titel: "",
    Type: route.params.type, // UP EVENT MISSION
    distance: "",
    discription: "",
    img_title: null,
    request_ranking: "",
    status: "",
    startDate: "",
    expireDate: "",
    reward: [],
    img_List: [],
    Achievement: null,
  });

  console.log(body);

  function mapReward(rawRewards) {
    const rewards = JSON.parse(rawRewards);

    return rewards.map((reward) => {
      if (reward.shirt) {
        return {
          type: 'ไอเทม',
          shirt: reward.shirt,
        }
      }
      if (reward.diamond != undefined) {
        return {
          type: 'ไดมอนด์',
          diamond: !reward.diamond ? "0" : reward.diamond,
        }
      }

      return {
        type: 'โกลด์',
        coin: reward.coin,
      };
    });
  }

  function mapValue(rawValues) {
    const values = JSON.parse(rawValues);
    return values.map((value) => {
      return {
        distance: value.distance,
        price: value.price,
        cost: value.cost,
        img_pre: value.img_pre,
        img_basic: value.img_basic,
      };
    })
  }

  useEffect(() => {
    if (route?.params?.id) {
      console.log('====================================');
      console.log(route?.params);
      console.log('====================================');
      setbody({
        ...route.params,
        reward: mapReward(route?.params?.reward ?? []),
        img_List: JSON.parse(route?.params?.img_List) ?? [],
      });
      setDataReward(mapReward(route?.params?.reward));
    }
  }, [focus]);

  const changeDate = (e) => {
    setDateState(e);
  };

  const changeDate1 = (e) => {
    setDateState1(e);
  };

  return (
    <View style={styles.container}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalresult}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalresult(!modalresult);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewinmodail}>
            <View
              style={{
                flexDirection: "row",
                width: width * 0.28,
                justifyContent: "space-between",
              }}
            >
              <Text
                style={[
                  styles.textname,
                  { alignSelf: "center" },
                  { marginLeft: 20 },
                ]}
              >
                เลือกไอเทม
              </Text>
              <TouchableOpacity
                onPress={() => setModalresult(!modalresult)}
                style={[
                  styles.tochup,
                  { backgroundColor: "#FCC81D" },
                  { marginLeft: 60 },
                ]}
              >
                <Text style={styles.textup}>ตกลง</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => setModalresult(!modalresult)}
                style={[styles.tochup, { marginLeft: 20 }]}
              >
                <Text style={styles.textup}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.line} />
            <View style={styles.liner}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  หัว
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        length == i
                          ? { shirt: { head: response } }
                          : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0]?.shirt == {} ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:

                          dataReward?.[0]?.shirt !=
                          undefined && dataReward?.[0]?.shirt,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
            <View style={[styles.liner, { borderLeftColor: "#F53C56" }]}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  เสื้อ
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        length == i
                          ? { shirt: { SHirt: response } }
                          : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0]?.shirt == null ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:

                          dataReward !=
                          undefined && dataReward?.[0]?.shirt.SHirt,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
            <View style={[styles.liner, { borderLeftColor: "#7764E4" }]}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  กางเกง
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        length == i
                          ? { shirt: { NET: response } }
                          : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0]?.shirt == null ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:

                          dataReward !=
                          undefined && dataReward?.[0]?.shirt.NET,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
            <View style={[styles.liner, { borderLeftColor: "#FEB969" }]}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  รองเท้า
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        index == i
                          ? { shirt: { SHoot: response } }
                          : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0]?.shirt == null ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:

                          dataReward !=
                          undefined && dataReward?.[0]?.shirt?.SHoot,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
          </View>
        </View>
      </Modal>

      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              EVENT{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>ภารกิจ </Text>
              </Text>
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>ADD</Text>
              </Text>
            </Text>
            <View style={styles.viewtouch}>
              <TouchableOpacity
                onPress={async () => {
                  delete dataReward.shirt;

                  let dada = {
                    ...body,
                    reward: dataReward,
                    Type: route?.params?.type,
                  };
                  const response = await apiservice({
                    path:
                      "/event/" +
                      (route?.params?.id ? "updatemission" : "create-mission"),
                    method: route?.params?.id ? "put" : "post",
                    body: dada,
                    token: token?.accessToken,
                  });

                  if (response.status == 200) {
                    navigation.goBack();
                  }
                }}
                style={styles.touchadd}
              >
                <Text style={styles.textadd}>บันทึก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => navigation.goBack()}
                style={styles.touchadd}
              >
                <Text style={styles.textadd}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.view}>
            <View style={styles.viewin}>
              <InputFree
                name="ชื่อรายการ"
                placeholder="กรอกชื่อรายการ"
                value={body.titel}
                onChangeText={(text) => {
                  setbody({ ...body, titel: text });
                }}
              />
              <InputFree
                name="ระยะทาง"
                value={body.distance}
                placeholder="กรอกระยะทางเป็นตัวเลข"
                onChangeText={(text) => {
                  setbody({ ...body, distance: text });
                }}
              />
              <Text style={styles.textname}>รายละเอียด</Text>
              <TextInput
                multiline
                value={body.discription}
                style={styles.textinput}
                placeholder="กรอกรายละเอียดเกี่ยวกับรายการนี้"
                onChangeText={(text) => {
                  setbody({ ...body, discription: text });
                }}
              />
              <View style={styles.kob}>
                <Text style={styles.textname}>รูปหน้าปก</Text>
                <View style={styles.style}>
                  {body.img_title == null ? (
                    <View style={styles.viewimg} />
                  ) : (
                    <Image
                      style={{ width: 120, height: 70, alignSelf: "center" }}
                      source={{
                        uri:

                          body.img_title,
                      }}
                    />
                  )}
                  <View style={{ marginLeft: 20 }}>
                    <View style={{ flexDirection: "row" }}>
                      <TouchableOpacity
                        onPress={async () => {
                          const response = await pickImage();
                          setbody({ ...body, img_title: response });
                        }}
                        style={[styles.tochup, { backgroundColor: "#FCC81D" }]}
                      >
                        <Text style={styles.textup}>Upload</Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={[styles.tochup, { marginLeft: 20 }]}
                      >
                        <Text style={styles.textup}>Reset</Text>
                      </TouchableOpacity>
                    </View>
                    <Text style={styles.textRe}>
                      Required image resolution 800x400, image size 10mb.
                    </Text>
                  </View>
                </View>
              </View>
              <InputFree
                name="เงื่อนไข"
                placeholder="กรอกระดับ lv เป็นตัวเลข"
                value={body.request_ranking}
                onChangeText={(text) => {
                  setbody({ ...body, request_ranking: text });
                }}
              />
            </View>
            <View style={styles.viewin}>
              <View
                style={[
                  styles.style,
                  { justifyContent: "space-between" },
                  { marginRight: 5 },
                ]}
              >
                <View>
                  <Text style={[styles.textname, { marginBottom: 5 }]}>
                    สถานะ
                  </Text>
                  <RNPickerSelect
                    value={body.status}
                    placeholder={placeholder}
                    onValueChange={(text) => setbody({ ...body, status: text })}
                    style={{
                      inputWeb: {
                        width: width * 0.18,
                        height: 30,
                        borderWidth: 1,
                        borderColor: "#ccc",
                        paddingLeft: 10,
                        borderRadius: 5,
                        color: "#777777",
                        fontFamily: "Prompt-Regular",
                        alignSelf: "center",
                      },
                    }}
                    items={items}
                  />
                </View>
                <View>
                  <Text style={[styles.textname, { marginBottom: 5 }]}>
                    แสดงผลวันที่
                  </Text>
                  <View style={{ gap: 10 }}>
                    <View style={{ flexDirection: "row" }}>
                      <TextInput
                        style={{
                          width: width * 0.18,
                          height: 30,
                          backgroundColor: "#fff",
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          paddingLeft: 25,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        }}
                        type={true}
                        Locate={locate}
                        setLo={setLo}
                        setHandelCalendar={setHandelCalendar}
                        value={moment(body.startDate).format("DD/MM/YYYY")}
                        onChangeText={(text) => {
                          setbody({ ...body, startDate: text });
                        }}
                      />
                      <TouchableOpacity
                        onPress={() => {
                          setHandelCalendar((val) => !val);
                        }}
                        style={styles.botton1}
                      >
                        <FontAwesome5
                          name="calendar-alt"
                          size={18}
                          color="#AFAFAF"
                        />
                      </TouchableOpacity>
                    </View>
                    <View style={{ flexDirection: "row" }}>
                      <TextInput
                        style={{
                          width: width * 0.18,
                          height: 30,
                          backgroundColor: "#fff",
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          paddingLeft: 25,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        }}
                        type={true}
                        Locate={locate1}
                        setLo={setLo1}
                        setHandelCalendar={setHandelCalendar1}
                        value={moment(body.expireDate).format("DD/MM/YYYY")}
                        onChangeText={(text) => {
                          setbody({ ...body, expireDate: text });
                        }}
                      />
                      <TouchableOpacity
                        onPress={() => {
                          setHandelCalendar1((val) => !val);
                        }}
                        style={styles.botton1}
                      >
                        <FontAwesome5
                          name="calendar-alt"
                          size={18}
                          color="#AFAFAF"
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
              <View>
                <Text style={[styles.textname, { marginVertical: 10 }]}>
                  ของรางวัล
                </Text>
                <FlatList
                  data={body.reward}
                  extraData={[body]}
                  contentContainerStyle={{ gap: 10 }}
                  ListFooterComponent={
                    <TouchableOpacity
                      onPress={() => {
                        setbody((val) => ({
                          ...val,
                          reward: body?.reward
                            ? val.reward.concat({ type: "" })
                            : [{ type: "" }],
                        }));
                        try {
                          setDataReward((val) => val.concat({ type: "" }));
                        } catch (error) {
                          setDataReward([{ type: "" }]);
                        }
                      }}
                      style={{
                        width: width * 0.395,
                        height: 30,
                        borderWidth: 1,
                        borderColor: "#ccc",
                        paddingLeft: 10,
                        borderRadius: 5,
                        color: "#777777",
                        fontFamily: "Prompt-Regular",
                        alignSelf: "center",
                        marginTop: 10,
                      }}
                    >
                      <Text style={styles.textup}>เพิ่ม</Text>
                    </TouchableOpacity>
                  }
                  renderItem={({ item, index }) => {
                    return (
                      <View style={{ backgroundColor: '#f4f4f4', borderRadius: 15, padding: 15 }}>
                        <Text style={styles.textname}>#{index + 1}</Text>
                        <TouchableOpacity
                          onPress={() => {
                            setbody((val) => ({
                              ...val,
                              reward: val.reward.filter((e, i) => i != index)
                            }));
                          }}
                          style={{
                            position: "absolute",
                            top: 5,
                            right: 5,
                          }}
                        >
                          <AntDesign
                            name="close"
                            size={14}
                            color="black"
                            style={{ marginLeft: -30, marginTop: 10 }}
                          />
                        </TouchableOpacity>
                        <RNPickerSelect
                          onValueChange={(text) => {
                            setbody((val) => ({
                              ...val,
                              reward: val.reward.map((itemss, indexss) => {
                                if (indexss == index) {
                                  return { ...itemss, type: text };
                                } else {
                                  return itemss;
                                }
                              }),
                            }));
                          }}
                          placeholder={placeholder2}
                          value={item.type}
                          style={{
                            inputWeb: {
                              width: '100%',
                              height: 30,
                              borderWidth: 1,
                              borderColor: "#ccc",
                              paddingLeft: 10,
                              borderRadius: 5,
                              color: "#777777",
                              fontFamily: "Prompt-Regular",
                              alignSelf: "center",
                              marginTop: 10,
                            },
                          }}
                          items={items2}
                        />
                        {item.type == "โกลด์" && (
                          <View
                            style={{
                              width: '100%',
                              flexDirection: "row",
                              justifyContent: "space-between",
                              marginTop: 10,
                            }}
                          >
                            <View style={{ width: '100%' }}>
                              <Text style={styles.textname}>จำนวน</Text>
                              <TextInput
                                value={item.coin}
                                onChangeText={(text) => {
                                  setbody((val) => ({
                                    ...val,
                                    reward: val.reward.map(
                                      (itemss, indexss) => {
                                        if (indexss == index) {
                                          return { ...itemss, coin: text };
                                        } else {
                                          return itemss;
                                        }
                                      }
                                    ),
                                  }));
                                  setDataReward(
                                    dataReward.map((e, i) => {
                                      return index == i
                                        ? { coin: text, type: "โกลด์" }
                                        : e;
                                    })
                                  );
                                }}
                                placeholder="กรอกเป็นตัวเลข"
                                style={{
                                  width: '100%',
                                  height: 30,
                                  fontFamily: "Prompt-Regular",
                                  borderWidth: 1,
                                  borderColor: "#ccc",
                                  backgroundColor: '#fff',
                                  paddingLeft: 10,
                                  borderRadius: 5,
                                  marginTop: 10,
                                }}
                              />
                            </View>
                            <View></View>
                          </View>
                        )}
                        {item.type == "ไดมอนด์" ? (
                          <View
                            style={{
                              width: '100%',
                              flexDirection: "row",
                              justifyContent: "space-between",
                              marginTop: 10,
                            }}
                          >
                            <View style={{ width: '100%', }}>
                              <Text style={styles.textname}>จำนวน</Text>
                              <TextInput
                                value={item.diamond}
                                onChangeText={(text) => {
                                  setbody((val) => ({
                                    ...val,
                                    reward: val.reward.map(
                                      (itemss, indexss) => {
                                        if (indexss == index) {
                                          return { ...itemss, diamond: text };
                                        } else {
                                          return itemss;
                                        }
                                      }
                                    ),
                                  }));
                                  setDataReward(
                                    dataReward.map((e, i) =>
                                      index == i
                                        ? { diamond: text, type: "ไดมอนด์" }
                                        : e
                                    )
                                  );
                                }}
                                placeholder="กรอกเป็นตัวเลข"
                                style={{
                                  width: '100%',
                                  height: 30,
                                  fontFamily: "Prompt-Regular",
                                  borderWidth: 1,
                                  borderColor: "#ccc",
                                  backgroundColor: '#fff',
                                  paddingLeft: 10,
                                  borderRadius: 5,
                                  marginTop: 10,
                                }}
                              />
                            </View>
                          </View>
                        ) : (
                          <View />
                        )}
                      </View>
                    );
                  }}
                />
              </View>
              <View style={styles.koblogo}>
                <View style={styles.style}>
                  {body.Achievement == null ? (
                    <View style={styles.viewimglogo} />
                  ) : (
                    <Image
                      style={{ width: 70, height: 70, alignSelf: "center" }}
                      source={{
                        uri:

                          body.Achievement,
                      }}
                    />
                  )}

                  <View style={{ marginLeft: 20 }}>
                    <View style={{ flexDirection: "row" }}>
                      <TouchableOpacity
                        onPress={async () => {
                          const response = await pickImage();
                          setbody({
                            ...body,
                            Achievement: response,
                          });
                        }}
                        style={[styles.tochup, { backgroundColor: "#FCC81D" }]}
                      >
                        <Text style={styles.textup}>Upload</Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={[styles.tochup, { marginLeft: 20 }]}
                      >
                        <Text style={styles.textup}>Reset</Text>
                      </TouchableOpacity>
                      <Text style={[styles.textname, { marginLeft: 40 }]}>
                        รูปสัญลักษณ์
                      </Text>
                    </View>
                    <Text style={styles.textRe}>
                      Required image resolution 70x70, image size 10mb.
                    </Text>
                  </View>
                </View>
              </View>
              <View
                style={[styles.kob, { height: 180 }, { paddingVertical: 10 }]}
              >
                <Text style={styles.textname}>รูปหน้าใน</Text>
                <FlatList
                  data={body.img_List}
                  horizontal
                  scrollEnabled={false}
                  ListFooterComponent={
                    <View
                      style={{
                        flexDirection: "row",
                        alignSelf: "center",
                        marginTop: 10,
                      }}
                    >
                      <TouchableOpacity
                        onPress={async () => {
                          const response = await pickImage();
                          console.log(body.img_List);
                          let arr = body.img_List || [];
                          let setArr = arr.concat(response);
                          setbody({ ...body, img_List: setArr });
                        }}
                        style={styles.viewimg}
                      >
                        <Image
                          style={{
                            width: 50,
                            height: 50,
                            position: "absolute",
                            alignSelf: "center",
                          }}
                          source={require("../../image/Group222.png")}
                        />
                      </TouchableOpacity>
                    </View>
                  }
                  renderItem={({ index, item }) => {
                    // console.log(item);
                    return (
                      <View>
                        <Image
                          style={{
                            width: 120,
                            height: 70,
                            alignSelf: "center",
                            marginTop: 10,
                            marginRight: 10,
                          }}
                          source={{
                            uri:
                              item,
                          }}
                        />
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await apiservice({
                              path: "/image/delete/" + item,
                              method: "delete",
                            });
                            let Arr = body.img_List.filter((e) => e != item);
                            setbody({ ...body, img_List: Arr });
                          }}
                          style={{
                            position: "absolute",
                            alignSelf: "flex-end",
                          }}
                        >
                          <AntDesign
                            name="close"
                            size={14}
                            color="black"
                            style={{ marginLeft: -30, marginTop: 10 }}
                          />
                        </TouchableOpacity>
                      </View>
                    );
                  }}
                />
              </View>
            </View>
          </View>
        </View>
        {handelCalendar && (
          <View
            style={{
              width: width * 0.18,
              position: "absolute",
              zIndex: 99,
              top: height * 0.32,
              left: width * 0.65,
            }}
          >
            <Text
              style={{
                fontSize: 10,
                color: "#000",
                textAlign: "center",
                fontFamily: "Prompt-Regular",
              }}
            >
              <Calendar
                value={dateState}
                onChangeText={(text) => {
                  setbody({ ...body, startDate: text });
                }}
                onChange={changeDate}
                onClickDay={(e) => {
                  setday(e);
                  setbody({ ...body, startDate: e });
                  setTimeout(() => {
                    setHandelCalendar((val) => !val);
                  }, 500);
                }}
              />
            </Text>
          </View>
        )}
        {handelCalendar1 && (
          <View
            style={{
              width: width * 0.18,
              position: "absolute",
              zIndex: 99,
              top: height * 0.35,
              left: width * 0.65,
            }}
          >
            <Text
              style={{
                fontSize: 10,
                color: "#000",
                textAlign: "center",
                fontFamily: "Prompt-Regular",
              }}
            >
              <Calendar
                value={dateState1}
                onChange={changeDate1}
                onChangeText={(text) => {
                  setbody({ ...body, expireDate: text });
                }}
                onClickDay={(a) => {
                  setday1(a);
                  setbody({ ...body, expireDate: a });
                  setTimeout(() => {
                    setHandelCalendar1((val) => !val);
                  }, 500);
                }}
              />
            </Text>
          </View>
        )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textadd1: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
  },
  viewtouch: {
    flexDirection: "row",
    width: width * 0.35,
    justifyContent: "flex-end",
    gap: 10,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewin: {
    width: width * 0.41,
    padding: 10,
    backgroundColor: "#ffffff",
  },
  koblogo: {
    width: width * 0.395,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  kob: {
    width: width * 0.395,
    height: 120,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  style: {
    flexDirection: "row",
    marginTop: 5,
  },
  viewimg: {
    width: 120,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },

  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textRe: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  touchlong: {
    width: width * 0.19,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  touchheigh: {
    width: width * 0.395,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  input: {
    width: width * 0.25,
    height: 33,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewinput: {
    flexDirection: "row",
    width: width * 0.36,
    justifyContent: "space-between",
  },
  textinput: {
    width: width * 0.395,
    height: 70,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewmain: {
    width: width * 0.395,
    height: 75,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingHorizontal: 10,
    borderRadius: 5,
    marginBottom: 10,
    marginTop: 10,
    justifyContent: "space-between",
    flexDirection: "row",
  },
  mainin: {
    width: width * 0.18,
    alignSelf: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  botton: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
  },
  inputimni: {
    width: width * 0.12,
    height: 38,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  botton1: {
    alignSelf: "center",
    marginLeft: -25,
  },
  backmodal: {
    width: width,
    height: height,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewinmodail: {
    width: width * 0.3,
    alignSelf: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    paddingVertical: 30,
  },
  imgko: {
    width: 25,
    height: 25,
    position: "absolute",
    alignSelf: "center",
    zIndex: 99,
  },
  line: {
    width: width * 0.3,
    borderBottomWidth: 0.5,
    borderColor: "#44444440",
    marginTop: 10,
  },
  liner: {
    flexDirection: "row",
    width: width * 0.28,
    justifyContent: "space-between",
    height: 40,
    borderLeftWidth: 1,
    borderLeftColor: "#2DCE98",
    marginTop: 10,
    alignSelf: "center",
  },
  ok: {
    width: 40,
    height: 40,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  real: {
    width: width * 0.28,
    justifyContent: "space-between",
    alignSelf: "center",
    flexDirection: "row",
  },
});
